import React from "react";
import {
  Mail,
  Phone,
  MapPin,
  Facebook,
  Instagram,
  Linkedin,
} from "lucide-react";

const Footer = () => {
  return (
    <footer className="lt-footer">
      <div className="lt-footer-container">
        {/* Brand / Logo */}
        <div className="lt-footer-column">
          <h2 className="lt-footer-logo">LIFTECH ENGINEERING PVT. LTD.</h2>
          <p className="lt-footer-tagline">Smart Parking Engineering</p>
        </div>

        {/* Quick Links */}
        <div className="lt-footer-column">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/projects">Projects</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="lt-footer-column">
          <h4>Contact</h4>
          <ul>
            {/* <li><Mail size={16} /> info@liftechparking.com</li> */}
            {/* <li><Phone size={16} /> +91 98765 43210</li> */}
            <li><MapPin size={16} /> Shop No. 104,First floor,
              Shabnam apartment,
              B P Road, Bhayandar ( East)
              Thane- 401105</li>
          </ul>
        </div>

        {/* Social Links */}
        <div className="lt-footer-column">
          <h4>Follow Us</h4>
          <div className="lt-footer-social">
            <a href="#"><Facebook size={20} /></a>
            <a href="#"><Instagram size={20} /></a>
            <a href="#"><Linkedin size={20} /></a>
          </div>
        </div>
      </div>

      {/* Bottom Strip */}
      <div className="lt-footer-bottom">
        <p>
          © {new Date().getFullYear()} All rights reserved. Powered by{" "}
          <a
            href="https://100billiontech.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            100BillionTech
          </a>
        </p>
      </div>

    </footer>
  );
};

export default Footer;
